import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20golden%20abstract%20gradient%20background%20with%20soft%20flowing%20curves%2C%20cinematic%20light%20leaks%2C%20elegant%20geometric%20shapes%2C%20minimalist%20modern%20design%2C%20luxurious%20feel%2C%20smooth%20texture&width=1600&height=500&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 to-background-950/50"></div>
      </div>

      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开启追剧之旅了吗？
        </h2>
        <p className="text-sm md:text-lg text-background-200 mb-8 max-w-[600px] mx-auto">
          加入桔子视频，畅享全网高清电视剧、电影、综艺，告别缓冲，尽享流畅体验！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hongtao"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-fill text-lg"></i>
            立即开始追剧
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}